import { PlotType } from '@/api/rest/resources/types/plot';
import { Logger } from '@/lib/logs/logger';
import { resolveThemeColor } from '@/utils/resolveThemeColor';

export const getColorOfPlotType = (type: PlotType): string => {
  switch (type) {
    case PlotType.BARE_AND_SPARSE_VEGETATION:
      return resolveThemeColor('landtypes-sparse-vegetation-main');
    case PlotType.BUILT_UP:
      return resolveThemeColor('landtypes-built-up-environment-main');
    case PlotType.FORESTRY:
      return resolveThemeColor('landtypes-forestry-main');
    case PlotType.CROPLAND:
      return resolveThemeColor('landtypes-cropland-main');
    case PlotType.GRASSLAND:
      return resolveThemeColor('landtypes-grassland-main');
    case PlotType.HERBACEOUS_WETLAND:
      return resolveThemeColor('landtypes-peatland-main');
    case PlotType.MANGROVES:
      return resolveThemeColor('landtypes-mangroves-main');
    case PlotType.MOSS_AND_LICHENS:
      return resolveThemeColor('landtypes-moss-and-lichens-main');
    case PlotType.SHRUBLAND:
      return resolveThemeColor('landtypes-shrubland-main');
    case PlotType.SNOW_AND_ICE:
      return resolveThemeColor('landtypes-snow-and-ice-main');
    case PlotType.TREE_COVER:
      return resolveThemeColor('landtypes-forestry-main');
    case PlotType.PERMANENT_WATER_BODIES:
      return resolveThemeColor('landtypes-permanent-water-bodies-main');
    case PlotType.MIXED:
      return resolveThemeColor('landtypes-mixed-main');
    case PlotType.SEAGRASS:
      return resolveThemeColor('landtypes-seagrass-main');
    case PlotType.UNDEFINED:
      return resolveThemeColor('text-secondary');
    default:
      Logger.error(`No color defined for plot type "${type}"`);
      return resolveThemeColor('black-100');
  }
};
